export { default as Header } from "./Header";
export { default as Footer } from "./Footer";
export { default as Point } from "./Point";
export { default as Image } from "./Image";
export { default as Pagination } from "./Pagination";
export { default as List } from "./List";
export { default as Link } from "./Link";
export { default as SectionDownloadApp } from "./SectionDownloadApp";
export { default as StructuredData } from "./StructuredData";
export { default as Icon } from "./Icon";
export { default as Button } from "./Button";
export { default as GoogleAnalytics } from "./GoogleAnalytics";
